<template>
  <div class="pg">
    <div class="item center" :class="current <= 1 ? 'disbale' : 'pg-index'" @click="onClick({ val: current - 1 })">
      <div class="left">→</div>
    </div>
    <div class="item center" :class="evaClass(item)" v-for="(item, index) in items" :key="item.val + index" @click="onClick(item)">
      {{ item.val }}
    </div>
    <div class="item center" :class="current >= total ? 'disbale' : 'pg-index'" @click="onClick({ val: current + 1 })">
      <div class="right">→</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    current: Number,
    total: Number,
  },
  computed: {
    items() {
      const vals = [];
      const edges = 1; //两侧显示的页码数 大于1
      const playes = 3; //主页码区显示的页码数 大于3
      let start = 1;
      let end = this.total;
      if (playes % 2) {
        //playes是奇数
        start = this.current - Math.floor(playes / 2);
        end = this.current + Math.floor(playes / 2);
      } else {
        //playes是偶数
        start = this.current - (playes / 2 - 1);
        end = this.current + playes / 2;
      }

      if (start <= edges + 1) {
        start = 1;
        if (end < playes && playes < this.total) {
          end = playes;
        }
      } else {
        for (var i = 1; i <= edges; i++) {
          vals.push({ val: i });
        }
        vals.push({ val: "...", ellipsis: true });
      }
      if (end < this.total - edges) {
        for (var i = start; i <= end; i++) {
          vals.push({ val: i });
        }
        vals.push({ val: "...", ellipsis: true });
        for (var i = this.total - edges + 1; i <= this.total; i++) {
          vals.push({ val: i });
        }
      } else {
        end = this.total;
        if (start > this.total - playes + 1) {
          start = this.total - playes + 1;
        }
        for (var i = start; i <= end; i++) {
          vals.push({ val: i });
        }
      }
      return vals;
    },
  },
  methods: {
    evaClass(item) {
      if (item.ellipsis) {
        return "ellipsis-item";
      }
      if (item.val === this.current) {
        return "pg-index pg-index-active";
      }
      return "pg-index";
    },
    onClick(item) {
      if (item.ellipsis) {
        return;
      }
      if (item.val < 1 || item.val > this.total) {
        return;
      }
      this.$emit("change", item.val);
    },
  },
};
</script>

<style lang="less" scoped>
.pg {
  display: flex;
  overflow: hidden;
  justify-content: center;
}

.item {
  width: 22px;
  height: 22px;
  // background-image: url(//img.souche.com/f2e/de846f8640b6ae6b46465723c710a493.svg);
  // background-repeat: no-repeat;
  // background-size: contain;
  border: 1px solid #b4b5b7;
  border-radius: 1px;
  box-sizing: border-box;
  cursor: pointer;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #b4b5b7;

  &:not(:first-child) {
    margin-left: 16px;
  }
}

.disbale {
  cursor: not-allowed;
}

.ellipsis-item {
  cursor: text;
}

.pg-index {
  &-active,
  &:hover {
    color: #ff571a;
    border-color: #ff571a;
    transition: ease all 0.3s;
  }
}

.left {
  pointer-events: none;
  transform: rotateZ(180deg) scale(0.8);
  font-size: 10px;
}

.right {
  pointer-events: none;
  font-size: 10px;
  transform: scale(0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue